// === Updated Contact.js ===

import React, { useState } from "react";
import axios from 'axios';
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import {
	faEnvelopeOpenText,
	faNetworkWired,
	faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import './ContactStyle.css';
import callusImage from "../assets/images/callus.png"; 

const contactInfoList = [
	{
		icon: faEnvelopeOpenText,
		label: "scholarize.contact@gmail.com",
		href: "mailto:scholarize.contact@gmail.com",
	},
	{ icon: faNetworkWired, label: "Scholarize.org", href: "" },
];

const ContactForm = () => {
	const [validated, setValidated] = useState(false);
	const [formData, setFormData] = useState({
		namee: '',
		phone: '',
		email: '',
		message: ''
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;
		if (!formData.namee || !formData.phone || !formData.email || !formData.message) {
			alert("لطفا تمام فیلدها را پر کنید");
			return;
		}
		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const response = await axios.post('/contact', formData); // Use proxy
				if (response.status === 200) {
					console.log('Form submission successful');
					setFormData({ namee: '', phone: '', email: '', message: '' });
					alert("پیام شما به دست ما رسید. در اسرع وقت با شما تماس میگیریم");
				} else {
					console.error('Form submission failed');
					alert("مشکلی پیش آمده. لطفا دوباره امتحان کنید یا با شماره‌‌‌‌ها تماس بگیرید.");
				}
			} catch (error) {
				console.error('Error:', error);
				alert("ارتباط با سرور ممکن نیست. لطفاً اتصال اینترنت یا آدرس سرور را بررسی کنید.");
			}
		}
		setValidated(true);
	};

	return (
		<Form noValidate validated={validated} onSubmit={handleSubmit}>
			<Form.Group className="mb-3 mt-2">
				<Form.Control 
					type="text" 
					name="namee"
					placeholder="Enter your Name" 
					value={formData.namee}
					onChange={handleChange} 
					required
				/>
			</Form.Group>
			<Form.Group className="mb-3 mt-2">
				<Form.Control
					type="tel" 
					placeholder="Your Phone Number"
					name="phone"
					value={formData.phone}
					onChange={handleChange}
					pattern="^[0-9]{10,12}$"
					title="Phone must be 10 to 12 digits"
					required
				/>
			</Form.Group>
			<Form.Group className="mb-3 mt-2">
				<Form.Control 
					type="email" 
					name="email"
					placeholder="Enter Your Email"
					value={formData.email}
					onChange={handleChange}
					required
				/>
			</Form.Group>
			<Form.Group className="mb-3">
				<Form.Control 
					as="textarea"
					name="message" 
					rows={4} 
					placeholder="Enter Message"
					value={formData.message}
					onChange={handleChange}
					required
				/>
			</Form.Group>
			<div className="text-end">
				<Button variant="primary" type="submit" className="ezy__contact10-btn">
					Submit
				</Button>
			</div>
		</Form>
	);
};

const ContactFormCard = () => (
	<Card className="ezy__contact10-form-card">
		<Card.Body className="p-md-5">
			<h2 className="ezy__contact10-heading mb-3" style={{ direction: "rtl" }}>با ما تماس بگیرید</h2>
			<p className="ezy__contact10-sub-heading mb-5" style={{ direction: "rtl" }}>
				جلسات مشاوره‌های ما رایگانه، از این فرصت استفاده کن. میتونی فرم زیر رو پر کنی تا ما با شما تماس بگیریم.
			</p>
			<ContactForm />
		</Card.Body>
	</Card>
);

const ContactInfo = ({ contactInfoList }) => (
	<div className="ezy__contact10-links">
		{contactInfoList.map((info, i) => (
			<Card className={classNames("ezy__contact10-link", { "mt-4": i })} key={i}>
				<Card.Body className="d-flex align-items-center" style={{ backgroundColor: 'rgb(199, 221, 255)', borderRadius: '10px' }}>
					<div className="fs-3 px-2 lh-2">
						<FontAwesomeIcon icon={info.icon} className="ezy__contact10-icon" />
					</div>
					<a className="ezy__contact10-link-content ms-4" href={info.href || "/"}>
						{info.label}
					</a>
				</Card.Body>
			</Card>
		))}
	</div>
);

ContactInfo.propTypes = {
	contactInfoList: PropTypes.array.isRequired,
};

const ContactUs = () => {
	return (
		<section className="ezy__contact10 light">
			<Container>
				<Row className="justify-content-between">
					<Col lg={6}>
						<ContactFormCard />
					</Col>
					<Col lg={6} className="order-lg-2 mb-3 mb-lg-0">
						<div className="ezy__contact10-bg-holder h-100 d-flex align-items-center py-5"
							style={{
								backgroundImage: `url(${callusImage})`,
								backgroundSize: "contain",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center",
							}}>
							<ContactInfo contactInfoList={contactInfoList} />
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default ContactUs;



